import defaultHandImage from "./hand_img.png";

const { Component, DOMUtils, Utils } = window.Liftoff;

const TEMPLATE = `<div class="hand-component">
  <div class="cue">
    <img class="hand" src=""/>
  </div>
</div>`;

const animations = {
  tap: "click-animate",
  "swipe left": "left-animate",
  "swipe right": "right-animate",
  "swipe up": "up-animate",
  "swipe down": "down-animate",
};

Component.register(
  "hand-component",
  class Counter extends Component {
    constructor(config) {
      super(config);

      Object.assign(
        this,
        Utils.mergePropertiesWithDefaults(
          {
            handStyle: null,
            clickInterval: 1000,
            customHandImage: null,
          },
          Utils.selectKeys(this.config, (_, val) => val != null)
        )
      );
    }

    load() {
      const promises = [Utils.loadImages([this.config.customHandImage])];
      return Promise.all(promises);
    }

    layout(parentNode) {
      this.el = DOMUtils.strToElement(TEMPLATE);
      this.handEl = this.el.querySelector(".cue > .hand");
      this._initializeLayout();

      // Render main component layout.
      super.layout(parentNode);
      this.parentNode.appendChild(this.el);

      this._initializeEvents();
    }

    _initializeLayout() {
      // Inicialize hand image.
      this.handEl.src = this.config.customHandImage || defaultHandImage;

      // Initialize style.
      Object.assign(this.handEl.style, this.config.handStyle);

      this.handEl.classList.add(animations[this.config.animation]);

      // Restart animations.
      if (this.config.clickInterval) {
        setInterval(() => {
          this.handEl.classList.remove(animations[this.config.animation]);
          this.el.getClientRects(); // Small trick to start dom reflow.

          // Add new
          this.handEl.classList.add(animations[this.config.animation]);
        }, this.config.clickInterval);
      }
    }

    _initializeEvents() {
      DOMUtils.on(this.el.closest("#liftoff-layout"), {
        "mouseup touchend click": () => {
          this._hide();
        },
      });
    }

    _hide() {
      this.el.style.display = "none";
    }

    start() {
      super.start();
    }

    stop() {
      super.stop();
      this._hide();
    }

    restart() {
      super.restart();
    }

    resize() {
      super.resize();
    }
  }
);



// WEBPACK FOOTER //
// ./components/hand/hand.js